import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmarkBox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 3v18h18V3H3zm2 16V5h14v14H5zM16.551 7.5048l-5.9727 6.0047-3.1593-3.1763-1.418 1.4104 4.5773 4.6019 7.3907-7.4303-1.418-1.4104z",
		fill: "#111"
	})
});
export default SvgCheckmarkBox;
